<template>
  <div class="body-main">


    <div class="cart-header">
      <div class="cart-header-warp clearfix">
        <div class="cart-title left clearfix">
          <h1 class="left">订单信息</h1>

        </div>
      </div>
    </div>
    <div class="cart-body" >
      <div class="title-box clearfix">
        <p class="l goods-info-title">商品信息</p>
      </div>
      <div class="detail-box">
        <ul>
          <li class="clearfix js-item-cart js-each-1192" >
            <img :src="this.baseUrl+this.orderInfo.pic_url" alt="" class="l">
            <div class="text-info-box l">
              <p class="package-title"></p>
              <a >
                <p class="package-info-title">{{this.orderInfo.title}}</p>
              </a>
            </div>
            <div class="info-price l">
              <em>￥</em>
              <span class="price">{{this.orderInfo.charge}}</span>

            </div>
          </li>
        </ul>
      </div>
      <div class="pay-box clearfix js-total-body-bot">
        <div class="row-bottom">
          <div class="row">
            <div class="goods-total-price-box clearfix">
              <p class="r rw price-num">
                <em>￥</em><span id="js-actual-price">{{this.orderInfo.charge}}</span>
              </p>
              <p class="r price-text"><span class="js-total-hide">共<span>1</span>件商品，</span>商品总金额：</p>
            </div>
          </div>
          <!-- 优惠券/优惠码抵扣 -->
          <!-- 优惠券抵扣end -->
          <!-- 组合套餐 or 学生优惠 -->
<!--          <div class="package-discount-box clearfix">-->
<!--            <p class="r rw price-num">-<em>￥</em><span id="js-discount-lose-money">0.00</span></p>-->
<!--            <p class="r price-text">优惠折扣：</p>-->
<!--          </div>-->
          <div class="package-discount-box clearfix">
            <p class="r rw price-num"><span >{{this.orderInfo.order_num}}</span></p>
            <p class="r price-text">订单号：</p>
          </div>
          <div class="package-discount-box clearfix">
            <p class="r rw price-num"><span >{{this.orderInfo.flow_num}}</span></p>
            <p class="r price-text">支付宝交易号：</p>
          </div>
          <div class="package-discount-box clearfix">
            <p class="r rw price-num"><span >{{this.orderInfo.orderCreateTime}}</span></p>
            <p class="r price-text">下订单时间：</p>
          </div>
          <div class="package-discount-box clearfix">
            <p class="r rw price-num"><span >{{this.orderInfo.flowCreateTime}}</span></p>
            <p class="r price-text">支付时间：</p>
          </div>
          <div class="package-discount-box clearfix">
            <p class="r rw price-num"><span >{{this.orderInfo.nickname}}</span></p>
            <p class="r price-text">购买用户：</p>
          </div>
          <div class="package-discount-box clearfix">
            <p class="r rw price-num"><span >{{this.orderInfo.phone}}</span></p>
            <p class="r price-text">联系电话：</p>
          </div>
          <!-- 组合套餐 or 学生优惠end -->
<!--          <div class="pay-price-box clearfix">-->
<!--            <p class="r rw price">-->
<!--              <em>￥</em><span id="js-pay-price">{{this.orderInfo.charge}}</span>-->
<!--            </p>-->
<!--            <p class="r price-text">应付：</p>-->
<!--          </div>-->
<!--          <div class="pay-add-sign">-->
<!--            <ul class="clearfix">-->
<!--              <li>支持花呗</li>-->
<!--              <li>可开发票</li>-->
<!--            </ul>-->
<!--          </div>-->
          <a  class="r moco-btn moco-btn-red submit-btn js-pay-submit" @click="goStudy()"  data-typecate="normal">去学习</a>
        </div>
      </div>

    </div>

  </div>




</template>

<script>
  import { getOrderInfo,createOrder,alipayReturnNotice} from '@/api/order'

  export default {
    name: "payResult",
    props:[
      'id'
    ],
    data(){
      return{
        orderInfo:{}
      }
    },
    created() {
      this.returnNotice()
      // this.getOrderInfo(this.id)
    },
    methods:{
      getOrderInfo(id){
        getOrderInfo(id).then(res=>{
          if (res.code === 20000){
            this.orderInfo = res.data;
          }
        })
      },
      createOrder(){
        createOrder(this.orderInfo.order_num).then(res=>{
          if (res.code === 20000){
            this.$router.push({ path:  '/pay/'+res.data })
          }
        })
      },
      returnNotice(){
        const param = this.$route.query
        alipayReturnNotice(param).then(res=>{
          if(res.message=='支付成功'){
           this.orderInfo = res.data
          }
        })
      },
      goStudy(){
        if(this.orderInfo.type===1){
          this.$router.push({ name: 'VideoDetail', params: {id: this.orderInfo.product_id}})
        }else if(this.orderInfo.type === 2) {
          this.$router.push({ name: 'Article', params: {id: this.orderInfo.product_id}})
        }

      }
    }
  }
</script>

<style scoped>
  .cart-header {
    margin-top: 10px;
    height: 160px;
    background-color: #e3e6e9;
    background: url(./../../assets/img/order/cart-header-bg.jpg) repeat-x left bottom;
  }
  .cart-header .cart-header-warp {
    width: 1104px;
    height: 120px;
    line-height: 120px;
    margin-left: auto;
    margin-right: auto;
    font-size: 14px;
  }
  .cart-header .cart-title {
    color: #4d555d;
    font-weight: 200;
    font-size: 14px;
  }
  .cart-header .left {
    float: left;
  }
  .cart-header .cart-title h1 {
    font-size: 32px;
    line-height: 115px;
    margin-right: 25px;
    color: #07111b;
    font-weight: 200;
  }
  .cart-body {
    width: 1152px;
    padding: 0 36px 32px;
    background-color: #fff;
    margin-top: -40px;
    margin-left: auto;
    margin-right: auto;
    box-shadow: 0 8px 16px 0 rgba(7,17,27,.1);
    border-radius: 8px;
    box-sizing: border-box;
  }
  .title-box {
    padding-top: 36px;
    padding-bottom: 24px;
  }
  .title-box .goods-info-title {
    margin-left: 12px;
    color: #07111b;
    font-size: 16px;
    line-height: 16px;
    /*font-weight: 500;*/
  }
  .l {
    float: left;
  }
  .detail-box {
    width: 100%;
  }
  .detail-box ul {
    width: 100%;
    padding-bottom: 36px;
    border-bottom: 1px solid #d9dde1;
  }
  ol, ul {
    list-style: none;
  }
  .detail-box ul li:last-child {
    margin-bottom: 0;
  }

  .detail-box ul li {
    padding: 24px;
    box-sizing: border-box;
    background: #f3f5f7;
    margin-bottom: 1px;
  }
  .clearfix:after {
    content: '\0020';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .content{
    width: 1200px;
    margin: auto;
  }

  blockquote, body, button, code, dd, div, dl, dt, fieldset, form, h1, h2, h3, h4, h5, h6, input, legend, li, ol, p, pre, td, textarea, th, ul {
    margin: 0;
    padding: 0;
  }
  a:link, a:visited {
    color: #5e5e5e;
  }
  :link, :visited, ins {
    text-decoration: none;
  }
  a {
    background-color: transparent;
  }
  user agent stylesheet
  a:-webkit-any-link {
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-box ul li img {
    width: 160px;
    height: 90px;
    margin-right: 24px;
  }

  fieldset, img {
    border: 0;
  }
  .detail-box ul li .text-info-box {
    width: 462px;
    height: 90px;
    margin-right: 120px;
  }
  .detail-box ul li .text-info-box .package-title {
    margin-top: 8px;
    font-size: 12px;
    color: #07111b;
    line-height: 24px;
  }
  .detail-box ul li .text-info-box .package-info-title {
    margin: 0;
    font-size: 16px;
    color: #07111b;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .detail-box ul li .info-price {
    position: relative;
    margin-top: 35px;
    width: 200px;
    font-size: 16px;
    color: #f01414;
  }
  .detail-box ul li .info-price .price {
    display: inline-block;
    width: 85px;
  }
  .pay-box {
    margin-top: 36px;
    position: relative;
  }
  .pay-box .bargain-discount-box, .pay-box .coupons-discount-box, .pay-box .goods-total-price-box, .pay-box .package-discount-box, .pay-box .student-discount-box {
    margin-bottom: 12px;
    line-height: 26px;
    width: 100%;
  }
  .pay-box .bargain-discount-box .price-num, .pay-box .coupons-discount-box .price-num, .pay-box .goods-total-price-box .price-num, .pay-box .package-discount-box .price-num, .pay-box .student-discount-box .price-num {
    position: relative;
    font-size: 14px;
    color: #07111b;
  }

  .pay-box .rw {
    width: 260px;
    box-sizing: border-box;
    text-align: right;
  }
  .r {
    float: right;
  }
  .pay-box .pay-price-box {
    color: #07111b;
  }
  .pay-box .pay-price-box .price {
    position: relative;
    color: #f01414;
    font-size: 24px;
    font-weight: 700;
  }
  em {
    font-style: normal;
  }
  .pay-box .pay-price-box .price span {
    float: none;
    font-weight: 700;
  }
  .pay-box .pay-add-sign {
    text-align: right;
    position: absolute;
    top: -10px;
  }
  .pay-box .pay-add-sign li {
    float: left;
    padding: 0 12px;
    height: 26px;
    line-height: 26px;
    border: 1px solid #f01414;
    border-radius: 18px;
    font-size: 12px;
    color: #f01414;
    margin-right: 15px;
  }

  .pay-box .submit-btn {
    padding: 0;
    width: 140px;
    height: 40px;
    margin-top: 12px;
    text-align: center;
    font-size: 14px;
    line-height: 40px;
    color: white;
  }

  .moco-btn-red:link, .moco-btn-red:visited {
    color: #fff !important;
  }
  .moco-btn:link, .moco-btn:visited {
    color: #545c63;
  }
  a:link, a:visited {
    color: #5e5e5e;
  }
  .r {
    float: right;
  }
  :link, :visited, ins {
    text-decoration: none;
  }
  .moco-btn-red {
    border-style: solid;
    border-width: 1px;
    cursor: pointer;
    -weibkit-transition: all .3s;
    -moz-transition: all .3s;
    transition: all .3s;
    color: #fff;
    background-color: #f20d0d !important;
    border-color: #f20d0d !important;
    opacity: 1;
  }
  .moco-btn {
    position: relative;
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    text-decoration: none;
    box-sizing: border-box;
    background-image: none;
    border-radius: 0;
    -webkit-appearance: none;
    white-space: nowrap;
    outline: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-style: solid;
    border-width: 1px;
    cursor: pointer;
    -weibkit-transition: all .3s;
    -moz-transition: all .3s;
    transition: all .3s;
    color: #545c63;
    background-color: transparent;
    border-color: #9199a1;
    opacity: 1;
    padding: 7px 16px;
    font-size: 14px;
    line-height: 1.42857143;
    border-radius: 18px;
  }

  .body-main {
    min-height: 800px;
    background: #fff;
    color: #5e5e5e;
    font: 14px/2em "PingFang SC","微软雅黑","Microsoft YaHei",Helvetica,"Helvetica Neue",Tahoma,Arial,sans-serif;
  }

</style>



// WEBPACK FOOTER //
// src/views/payresult/payResult.vue